// Retorno SSO para quem ja esta logado.
//
// Subdominios (financeiro.dale365.com, app.dale365.com) reconhecem a sessao
// pelo cookie `dale365_token`, que o Login.vue so grava no submit do login. Um
// usuario que ja esta logado e chega em /login?next=<subdominio> nao passa
// pelo submit: sem isto, o guard do router o mandava para /partidas-v2 e ele
// nunca voltava ao subdominio (#310).
//
// Modulo puro (sem window/document) para ser testado com node --test.

export const SSO_COOKIE_NAME = 'dale365_token';
const COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 30;
const RETRY_WINDOW_MS = 30 * 1000;
const STORAGE_PREFIX = 'ssoReturn:';

// So subdominios https de dale365.com. O proprio dale365.com fica de fora: la o
// localStorage ja basta e o guard segue o caminho normal.
export function trustedSsoTarget(rawNext, baseOrigin) {
  const value = Array.isArray(rawNext) ? rawNext[0] : rawNext;
  if (typeof value !== 'string' || value.length === 0) return null;
  let parsed;
  try {
    parsed = new URL(value, baseOrigin);
  } catch (e) {
    return null;
  }
  if (parsed.protocol !== 'https:') return null;
  if (parsed.username || parsed.password) return null;
  if (!parsed.hostname.endsWith('.dale365.com')) return null;
  if (parsed.hostname === 'www.dale365.com') return null;
  return parsed;
}

export function ssoCookieString(token, hostname, protocol) {
  const attrs = [
    SSO_COOKIE_NAME + '=' + encodeURIComponent(token),
    'path=/',
    'max-age=' + COOKIE_MAX_AGE_SECONDS,
    'SameSite=Lax',
  ];
  if (hostname === 'dale365.com' || hostname.endsWith('.dale365.com')) attrs.push('Domain=.dale365.com');
  if (protocol === 'https:') attrs.push('Secure');
  return attrs.join('; ');
}

// Decide se o usuario logado deve ser devolvido ao subdominio. Devolve
// { url, cookie } ou null (= siga o fluxo normal).
//
// Anti-loop: se o subdominio recusar o token ele manda o usuario de volta para
// /login?next=...; a segunda passagem dentro da janela cai no fluxo normal em
// vez de ficar a quicar entre os dois sites.
export function resolveSsoReturn({ rawNext, token, location, storage, now = Date.now() }) {
  if (!token) return null;
  const target = trustedSsoTarget(rawNext, location.origin);
  if (!target) return null;

  const key = STORAGE_PREFIX + target.hostname;
  const last = Number(storage.getItem(key) || 0);
  if (last && now - last < RETRY_WINDOW_MS) return null;
  storage.setItem(key, String(now));

  return {
    url: target.toString(),
    cookie: ssoCookieString(token, location.hostname, location.protocol),
  };
}
